import {DesktopSize} from "@/components/responsive";
import {IMAGE_URL, LOCAL_IMAGE_URL} from "@/constants/general-constants";
import {ImageWithFallback} from "@/components";
import {isEmpty} from "@/utils/global-functions";

export default function PolSupport({data = {}}) {

    const {contact_ending_section = {}} = data && !isEmpty(data.data) ? data.data : {};

    return (
        <section className="container mt-12 lg:mt-[5.563rem]">
            <div className="flex items-center justify-between gap-x-7 text-pol-dark-800">
                <div className="pt-8 mobile-content-p">
                    <h3 className="font-bold text-xl lg:text-[1.75rem]">{contact_ending_section?.title}</h3>
                    <div className="pol-leading-lg text-justify mt-6 space-y-4">
                        {contact_ending_section?.text}
                    </div>
                    <a
                        href={process.env.NEXT_PUBLIC_FREELANCER_URL + "/support/new-ticket"}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn-orange px-4 py-3 text-sm font-semibold mt-6"
                    >
                        <span>ارسال تیکت</span>
                        <i className="icon-ticket mr-5"/>
                    </a>
                </div>
                <DesktopSize>
                    <div className="rounded-[3rem] min-w-[24.5rem] h-[25rem] overflow-hidden">
                        <div className="relative w-full h-full">
                            <div
                                className="absolute left-[1.25rem] top-[1.25rem] z-10 rounded-[2.188rem] border-[0.188rem] border-white w-[calc(100%-2.5rem)] h-[calc(100%-2.5rem)]"></div>
                            <ImageWithFallback
                                className="object-cover"
                                alt="Perspective"
                                fill
                                src={contact_ending_section ? IMAGE_URL + contact_ending_section.image : ""}
                            />
                        </div>
                    </div>
                </DesktopSize>
            </div>
        </section>
    )
}
